<template>
  <div
    @keydown="progressbar.userKeyDown()"
    @keyup="progressbar.userKeyUp()"
    @click="calculate_progress"
  >
    <!-- Popup modal create evaluation -->
    <create-evaluation-popup
      :is-opened="show_add_evaluation || false"
      :date-debut="form.date_debut_evaluation"
      :date-fin="form.date_fin_evaluation"
      @close="show_add_evaluation = false"
      @changeDateDebut="
        (newValue) => {
          if (
            form.date_fin_evaluation == '' ||
            $verifyDates({ debut: newValue, fin: form.date_fin_evaluation })
          ) {
            form.date_debut_evaluation = newValue;
          } else {
            badDates();
            form.date_debut_evaluation = '';
          }
        }
      "
      @changeDateFin="
        (newValue) => {
          if (
            form.date_debut_evaluation == '' ||
            $verifyDates({ debut: form.date_debut_evaluation, fin: newValue })
          ) {
            form.date_fin_evaluation = newValue;
          } else {
            badDates();
            form.date_fin_evaluation = '';
          }
        }
      "
      @createEvaluation="create_evaluation"
    />
    <!-- END Popup modal create evaluation -->

    <!-- BEGIN Popup to confirm to close an evaluation -->
    <close-evaluation-popup
      :is-opened="confirmCloseEvaluation > -1"
      :is-step-one="confirmCloseEvaluation == 0"
      :is-step-two="confirmCloseEvaluation == 1"
      :today="today"
      @close="confirmCloseEvaluation = -1"
      @closeEval="close_eval"
    />
    <!-- END Popup to confirm to close an evaluation -->

    <!-- BEGIN Popup to choose a job description -->
    <choose-job-desc-popup
      :is-displayed="isNewSheetPopupDisplayed || false"
      @close="toggleAddJobPopup(false)"
      :job-not-found="jobNotFound || false"
      :libelle-page="infosPage.libelle_page"
      :deleted-desc="deletedDesc"
      :num-job="job"
      @hasResult="
        (hasResultFound) => {
          noSearchResult = hasResultFound;
        }
      "
      @selectJobDesc="
        (selectedJob) => {
          addJob(selectedJob);
        }
      "
      ref="addJobPopup"
      :type-structure="constants.TYPE_OF"
    />
    <!-- END Popup to choose a job description -->

    <!-- BEGIN Popup to confirm to remove a poste  -->
    <popup
      :opened="isPopupConfirmRemovePosteDisplayed > -1"
      @close="isPopupConfirmRemovePosteDisplayed = -1"
    >
      <!-- Screen to ask a confirmation to remove the poste -->
      <div v-if="isPopupConfirmRemovePosteDisplayed === 0">
        <div class="mx-5 xl:mx-20 my-8 w-auto h-auto">
          <h3 class="mb-10">
            Retirer le référentiel de formation {{ jobForm.nom_du_poste }}
          </h3>

          <p class="text-indigo-600 text-lg text-center">
            Êtes-vous sûr de vouloir retirer le référentiel
            {{ jobForm.nom_du_poste }} du poste {{ job }}, concernant le
            bénéficiaire {{ infosPass.name }} ?
          </p>
          <p class="text-indigo-600 text-lg text-center">
            Cette action sera définitive et irrévocable.
          </p>
          <p class="text-indigo-600 text-lg text-center">
            Vous pouvez continuer à consulter les historiques des évaluations.
          </p>

          <div class="flex justify-center mt-10">
            <action-button
              border-color="border-transparent"
              text-color="text-white"
              bg-color="bg-pink-600"
              bg-color-square="bg-pink-600"
              icon-color="text-white"
              libelle="CONFIRMER"
              :uppercase="true"
              icon="trash-2"
              :right="true"
              type-shadow="shadow-pink"
              @clickAction="removeCurrentPoste()"
            />
          </div>
        </div>
      </div>
      <!-- END Screen to ask a confirmation to remove the poste -->

      <!-- Screen to confirm the remove -->
      <div v-if="isPopupConfirmRemovePosteDisplayed === 1">
        <div class="mx-5 xl:mx-6 my-8 w-auto h-auto">
          <h3 class="mb-10 text-pink-600">Référentiel de formation retiré</h3>
          <p class="text-indigo-600 text-lg text-center">
            La référentiel de formation {{ job }} a bien été retiré
          </p>
          <p
            v-if="listEvaluations.length > 0"
            class="text-indigo-600 text-lg text-center"
          >
            Vous pouvez consulter les historiques des évaluations liés à ce
            poste
          </p>
          <illustration name="basket" class="w-full my-10" />
        </div>
      </div>
      <!-- END Screen to confirm the remove -->
    </popup>
    <!-- END Popup to confirm to remove a poste -->

    <h3 class="my-15 2xl:my-20 mx-1/4">
      {{ getLibelle({ infosPage }) }}
    </h3>

    <!-- BEGIN Button add evaluation -->
    <div
      class="m-5 lg:m-15 mb-0"
      v-if="
        form.date_debut_evaluation == '' ||
        form.date_fin_evaluation == '' ||
        form.id_ref == 0 ||
        form.template == {}
      "
    >
      <div
        v-if="
          $can(infosPage.name_page + '_edit', infosPass.id_pass) &&
          role !== constants.ROLE_BENEFICIAIRE
        "
      >
        <div class="flex justify-center w-full">
          <span
            v-if="
              (jobs[job - 1] === undefined
                ? jobs[job - 1] === undefined
                : jobs[job - 1].id) &&
              $can(infosPage.name_page + '_edit', infosPass.id_pass) &&
              !jobNotFound
            "
          >
            <action-button
              border-color="border-transparent"
              text-color="text-white"
              bg-color="bg-indigo-600"
              bg-color-square="bg-indigo-600"
              icon-color="text-white"
              libelle="AJOUTER UNE ÉVALUATION"
              :uppercase="true"
              icon="plus-circle"
              type-shadow="shadow-indigo"
              @clickAction="show_add_evaluation = true"
            />
          </span>
          <span
            v-else-if="
              role !== constants.ROLE_BENEFICIAIRE &&
              (jobs[job - 1] || jobs[job - 1].id || jobNotFound)
            "
          >
            <action-button
              border-color="border-transparent"
              text-color="text-white"
              bg-color="bg-indigo-600"
              bg-color-square="bg-indigo-600"
              icon-color="text-white"
              libelle="CHOISIR UN RÉFÉRENTIEL DE FORMATION"
              icon="file-text"
              type-shadow="shadow-indigo"
              @clickAction="
                loadJobs();
                toggleAddJobPopup(true);
              "
            />
          </span>
          <div v-else class="text-indigo-600 text-lg text-center">
            Vous n'avez pas sélectionné de référentiel de formation.
          </div>
        </div>
        <div class="flex justify-center w-full">
          <illustration name="evaluation" class="mt-15" />
        </div>
        <div
          v-if="role !== constants.ROLE_BENEFICIAIRE && jobForm.nom_du_poste"
          class="flex justify-center w-full mt-15"
        >
          <div class="w-max">
            <action-button
              border-color="border-transparent"
              text-color="text-white"
              text-color-hover="hover:text-white"
              bg-color="bg-indigo-600"
              bg-color-hover="hover:bg-pink-600"
              bg-color-square="bg-indigo-600"
              bg-color-square-hover="group-hover:bg-pink-600"
              icon-color="text-white"
              icon-color-hover="hover:text-white"
              :libelle="
                'Retirer le référentiel de formation' +
                (!$isMobile()
                  ? ' ”' + jobForm.nom_du_poste + '” du poste ' + job
                  : '')
              "
              icon="trash-2"
              type-shadow="shadow-indigo"
              type-shadow-hover="hover:shadow-pink"
              @clickAction="displayConfirmRemovePoste()"
            />
          </div>
        </div>
      </div>
      <div v-else>
        <div class="text-indigo-600 text-lg text-center">
          Il n’y a pas d’évaluation en cours
          <span v-if="listEvaluations.length > 0">
            , vous pouvez consulter
            <br />
            vos évaluations précédentes dans l’historique ci-dessous
          </span>
          .
        </div>
        <div class="flex justify-center w-full">
          <illustration name="notAllowed" class="mt-15" />
        </div>
      </div>
    </div>
    <!-- END Button add evaluation -->

    <!-- BEGIN Evaluation content -->
    <div v-else>
      <!-- data comes from CompetenceChart mixin -->
      <PopupCompareCarto
        :compare-carto="compareCarto"
        @close="closeCompare"
        @changeCompare="
          (index) => {
            changeCompare(index);
          }
        "
        :carto-to-compare="cartoToCompare"
        :history-to-display="historyToDisplay"
        :competences-cles="{}"
        :history-competences-cles="[]"
        :competences-informatique="{}"
        :history-competences-informatique="[]"
        :competences-linguistique="{}"
        :history-competences-linguistique="[]"
        :competences-socio-pro="{}"
        :history-competences-socio-pro="{}"
        :competences-pro="{}"
        :history-competences-pro="{}"
        :competences-sco="competencesSco"
        :history-competences-sco="
          Object.fromEntries(
            Object.entries(historyCompetencesSco).filter(
              ([pageName, hist]) =>
                hist.template_name == competencesSco.template_name &&
                pageName == infosPage.name_page
            )
          )
        "
        v-if="compareCarto"
      />
      <!-- Bloc action buttons -->
      <div
        v-if="
          role !== constants.ROLE_BENEFICIAIRE &&
          $can(infosPage.name_page + '_edit', infosPass.id_pass)
        "
        class="w-full mb-15 2xl:mb-20 flex justify-center"
      >
        <list-action-buttons
          :today="today"
          :libelle-template="form.name_job"
          :can-compare-cartography="
            $can(constants.PERMISSION_CARTOGRAPHIE_INDIVIDUELLE_COMPARE) &&
            listEvaluations.length > 0
          "
          :can-compare-but-not-enough-evaluation="
            $can(constants.PERMISSION_CARTOGRAPHIE_INDIVIDUELLE_COMPARE) &&
            listEvaluations.length === 0
          "
          @confirmCloseEvaluation="confirmCloseEvaluation = 0"
          @displayCompareCarto="
            displayCompareCarto('compsco/' + infosPage.name_page)
          "
        />
      </div>
      <!-- Bloc action buttons -->

      <!-- BEGIN Remplir avec le modèle de page correspondant -->
      <!-- BEGIN Evaluation with referentiel formation -->
      <div v-if="jobType === 'ref_formation'">
        <div
          v-if="jobForm.modules && jobForm.modules.length > 0"
          class="text-lg text-gray-600 grid grid-cols-12 gap-x-4 place-content-center h-16 2xl:h-24"
        >
          <div class="col-start-3 lg:col-start-2 col-span-6 md:col-span-7">
            Domaines
          </div>
          <div class="col-span-4">Temps consacré</div>
        </div>

        <!-- BEGIN list of parcours -->
        <div
          v-for="(mod, num) in jobForm.modules"
          :key="num"
          class="odd:bg-indigo-100 odd:bg-opacity-50"
        >
          <!-- BEGIN Informations on accordion -->
          <div
            class="h-auto py-5 min-h-16 lg:min-h-24 2xl:min-h-32 cursor-default hover:bg-indigo-200 grid grid-cols-12 gap-x-4 items-center place-content-center"
            :class="{
              'bg-indigo-200 border-l-2 border-indigo-600':
                itemDisplayed == num,
            }"
            @click="displayItem(num)"
            :id="'module' + num"
          >
            <div
              class="col-span-2 md:col-span-1 text-pink-600 justify-self-center flex flex-col justify-around"
            >
              <icon
                class="transform transition-transform ease-in-out duration-300"
                :class="{ 'rotate-90': itemDisplayed == num }"
                name="chevron-right"
              />
            </div>
            <div class="col-span-6 md:col-span-7 text-base font-normal">
              <span>{{ mod.module_name }}</span>
            </div>
            <div class="col-span-4 text-base font-normal">
              <span
                v-if="
                  form.items.modules[num].general.filter((gen) =>
                    gen.name.includes('Temps')
                  )[0].value !== '' ||
                  form.items.modules[num].general.filter((gen) =>
                    gen.name.includes('Temps')
                  )[0].value !== undefined ||
                  form.items.modules[num].general.filter((gen) =>
                    gen.name.includes('Temps')
                  )[0].value !== null ||
                  form.items.modules[num].general.filter((gen) =>
                    gen.name.includes('Temps')
                  )[0].value !== []
                "
              >
                {{
                  form.items.modules[num].general.filter((gen) =>
                    gen.name.includes('Temps')
                  )[0].value
                }}
              </span>
            </div>
          </div>
          <transition
            enter-active-class="ease-out duration-300"
            enter-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            enter-to-class="opacity-100 translate-y-0 sm:scale-100"
            leave-active-class="ease-in duration-200"
            leave-class="opacity-100 translate-y-0 sm:scale-100"
            leave-to-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
          >
            <!-- END Content modal -->
            <div
              v-if="itemDisplayed === num"
              class="bg-white my-5 lg:my-10 px-10"
            >
              <div class="grid grid-cols-12 gap-x-4 gap-y-4 lg:gap-y-10 mb-15">
                <div
                  v-for="(gen, index) in form.template.filter(
                    (temp) =>
                      !['Critères d\'évaluation', 'Critères'].includes(
                        temp.libelle
                      )
                  )"
                  :key="index"
                  class="col-span-full md:col-span-6"
                >
                  <input-select
                    :disabled="role === constants.ROLE_BENEFICIAIRE"
                    :name="gen.libelle.replace('\'', '')"
                    :necessary="true"
                    :libelle="gen.libelle"
                    :value="form.items.modules[num].general[index].value"
                    :datas="gen.criterions"
                    @input="
                      (newValue) => {
                        $set(
                          form.items.modules[num].general[index],
                          'value',
                          newValue
                        );
                      }
                    "
                  />
                </div>
              </div>

              <module-category
                :datas="mod.module_competences"
                :form="form.items.modules[num].module_competences"
                :list-criterions="listCriterions"
                name="module_competences"
                :is-necessary="true"
                :id-pass="infosPass.id_pass"
                :id-user="user.id"
                :hidden-fields="hiddenFields"
                :latest-eval="
                  ((((latestEval || {}).items || {}).modules || [])[num] || {})
                    .module_competences || []
                "
                :preview-mode="false"
                @setAutoEvaluation="
                  (numCompetence, numCritere, newValue) => {
                    $set(
                      form.items.modules[num].module_competences[numCompetence]
                        .criterions[numCritere],
                      'auto',
                      newValue
                    );
                  }
                "
                @setReferentEvaluation="
                  (numCompetence, numCritere, newValue) => {
                    $set(
                      form.items.modules[num].module_competences[numCompetence]
                        .criterions[numCritere],
                      'value',
                      newValue
                    );
                  }
                "
                @setComment="
                  (numCompetence, numCritere, newValue) => {
                    $set(
                      form.items.modules[num].module_competences[numCompetence]
                        .criterions[numCritere],
                      'comment',
                      newValue
                    );
                  }
                "
                @hideField="
                  (field) => {
                    hiddenFields[field] = !hiddenFields[field];
                  }
                "
              />

              <module-category
                :datas="mod.module_competences_transversales"
                :form="form.items.modules[num].module_competences_transversales"
                :list-criterions="listCriterions"
                name="module_competences_transversales"
                :is-necessary="true"
                :id-pass="parseInt(infosPass.id_pass)"
                :id-user="parseInt(user.id)"
                :hidden-fields="hiddenFields"
                :latest-eval="
                  ((((latestEval || {}).items || {}).modules || [])[num] || {})
                    .module_competences_transversales || []
                "
                :preview-mode="false"
                @setAutoEvaluation="
                  (numCompetence, numCritere, newValue) => {
                    $set(
                      form.items.modules[num].module_competences_transversales[
                        numCompetence
                      ].criterions[numCritere],
                      'auto',
                      newValue
                    );
                  }
                "
                @setReferentEvaluation="
                  (numCompetence, numCritere, newValue) => {
                    $set(
                      form.items.modules[num].module_competences_transversales[
                        numCompetence
                      ].criterions[numCritere],
                      'value',
                      newValue
                    );
                  }
                "
                @setComment="
                  (numCompetence, numCritere, newValue) => {
                    $set(
                      form.items.modules[num].module_competences_transversales[
                        numCompetence
                      ].criterions[numCritere],
                      'comment',
                      newValue
                    );
                  }
                "
                @hideField="
                  (field) => {
                    hiddenFields[field] = !hiddenFields[field];
                  }
                "
              />
            </div>
          </transition>
        </div>
      </div>
      <!-- END Evaluation with referentiel formation -->

      <!-- BEGIN EVALUATION TYPE ROME -->
      <evaluation-rome
        v-if="jobType === 'rome'"
        :form="form"
        @changeValue="
          (infos) => {
            form.items[infos.typeCompetence][infos.typeSavoir][infos.value.key][
              infos.evaluatorType
            ] = infos.value.value;
          }
        "
        :id-pass="infosPass.id_pass"
        :id-user="user.id"
      />
      <!-- END EVALUATION TYPE ROME -->

      <!-- END Remplir avec le modèle de page correspondant -->
    </div>
    <!-- END Evaluation content -->
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex';

import InputSelect from '../../../components/Inputs/InputSelect';
import ClickOutside from 'vue-click-outside';

import ActionButton from '../../../components/ActionButton';
import Icon from '../../../components/Icon';
import Illustration from '../../../components/Illustration';
import Popup from '../../../components/Popup';

import axios from './../../../api';
import store from './../../../store';
import VerifyDates from '../../../mixins/VerifyDates';
import Constants from '../../../constants';
import PopupCompareCarto from '../../../components/Cartographies/PopupCompareCarto';
import Layout from './../../../mixins/Layout';

import ModuleCategory from './../../../components/CompetencesPro/ModuleCategory';
import EvaluationRome from '../../../components/CompetencesPro/EvaluationRome.vue';

import CreateEvaluationPopup from '../../../components/Evaluations/CreateEvaluationPopup.vue';
import ListActionButtons from '../../../components/Evaluations/ListActionButtons.vue';
import CloseEvaluationPopup from '../../../components/Evaluations/CloseEvaluationPopup.vue';
import ChooseJobDescPopup from '../../../components/CompetencesPro/ChooseJobDescPopup.vue';

export default {
  components: {
    EvaluationRome,
    ActionButton,
    InputSelect,
    Icon,
    Illustration,
    Popup,
    PopupCompareCarto,
    ModuleCategory,
    CreateEvaluationPopup,
    ListActionButtons,
    CloseEvaluationPopup,
    ChooseJobDescPopup,
  },

  props: ['progressbar'],

  name: 'CompetencesScolaire',
  mixins: [VerifyDates, Layout],

  data() {
    return {
      // Initial state of the form
      form: {
        id_ref: 0,
        version_template: 0,
        type_temp: '',
        name_temp: '',
        template: [{}, {}],
        date_debut_evaluation: '',
        date_fin_evaluation: '',
        items: { modules: [] },
      },

      // Initial state of the form
      emptyForm: {
        id_ref: 0,
        version_template: 0,
        type_temp: '',
        name_temp: '',
        template: [{}, {}],
        date_debut_evaluation: '',
        date_fin_evaluation: '',
        items: { modules: [] },
      },

      deletedDesc: {},
      show_add_evaluation: false,
      confirmCloseEvaluation: -1, //-1 : modal closed / 0 : confirm close / 1 : evaluation closed
      itemDisplayed: -1,
      showAddJob: false,
      currentSector: '',
      showJob: false,
      messageHeader: '',
      smallBar: false,
      progressBar: '',
      progress: 0,
      goal: 75,
      showList: false,
      currentModule: 0,
      sectors: [],
      families: [],
      descs: [],
      selectedDesc: {},
      selectedSector: {},
      selectedFamily: {},
      filteredDescs: [],
      noSearchResult: false,
      noAdvancedSearchResult: false,

      //Hide or show each field
      hiddenFields: {
        last_module_competences: true,
        last_module_competences_transversales: true,

        auto_module_competences: true,
        auto_module_competences_transversales: true,
      },
      tableDisplay: true, // by screen size, datas display in table or by rows

      cartoToCompare: '',
      compareCarto: false,
      colors: {
        beneficiary: '#21B8C8',
        referent: '#FF1C80',
      },
      historyToDisplay: -1,
      isPopupConfirmRemovePosteDisplayed: -1,

      showTypeCompetenceChoice: false,
      typeCompetenceChosen: 'Compétences de base',
      constants: Constants,
    };
  },

  //to reinit the new form
  async beforeRouteEnter(to, from, next) {
    //reload page infos before load jobs infos because some info not load in this context
    let url = to.path.split('/form/neopass/')[1].split('/');
    await store.dispatch('neopass/update_infos_page', url);

    next((vm) => {
      vm.initPage();
    });
  },

  mounted() {
    if (window.matchMedia('(max-width: 1279px)').matches) {
      this.tableDisplay = false;
    } else {
      this.tableDisplay = true;
    }

    this.calculate_progress();
  },

  methods: {
    ...mapMutations({
      SET_FORMCONTENT: 'neopass/SET_FORMCONTENT',
      SET_INFOSPAGE: 'neopass/SET_INFOSPAGE',
      SET_JOBS: 'neopass/SET_JOBS',
      SET_JOB: 'neopass/SET_JOB',
      SET_JOBFORM: 'neopass/SET_JOBFORM',
      SET_JOBTYPE: 'neopass/SET_JOBTYPE',
      SET_JOBID: 'neopass/SET_JOBID',
      calculate_progress: 'neopass/calculate_progress',
    }),
    ...mapActions({
      save_datas: 'neopass/save_datas',
      close_evaluation: 'neopass/close_evaluation',
      remove_poste: 'neopass/remove_poste',
      load_infos_pass: 'cartographiesIndividuelles/load_infos_pass',
      load_evaluations: 'cartographiesIndividuelles/load_evaluations',
      getJob: 'neopass/getJob',
      loadJobs: 'neopass/loadJobs',
      load_infos_job: 'neopass/load_infos_job',
    }),

    loadEmptyForm() {
      this.deletedDesc = {};
      this.form = JSON.parse(JSON.stringify(this.emptyForm));
    },

    initForm() {
      //load values in form and keep formContent with initial values to compare when leave page without saving
      Object.assign(this.form, this.formContent);
    },

    async initPage() {
      await store.commit('app/SET_LOADING', true);
      await this.toggleAddJobPopup(true);
      await this.loadEmptyForm();
      await this.initForm();

      await this.resetHiddenFields();

      store.commit('app/SET_LOADING', false);

      this.infosPage.isFormChanged = false;
    },

    resetHiddenFields() {
      if (this.infosPass.id_pass == this.user.id) {
        this.hiddenFields = {
          last_module_competences: false,
          last_module_competences_transversales: false,

          auto_module_competences: false,
          auto_module_competences_transversales: false,
        };
      } else {
        this.hiddenFields = {
          last_module_competences: true,
          last_module_competences_transversales: true,

          auto_module_competences: true,
          auto_module_competences_transversales: true,
        };
      }
    },

    calculate_progress() {
      let fields = document.querySelectorAll('[necessary=true]');
      let completeField = 0;
      let val = null;

      fields.forEach((element) => {
        if (this.form[element.name] !== 'modules') {
          val = this.form[element.name];
          if (val !== null && val !== undefined) {
            if (val.toString() != '' || val.length > 0) {
              completeField++;
            }
          }
        }
      });

      if (fields.length > 0) {
        //update progress for progress bar
        this.progress = Math.ceil((completeField / fields.length) * 100);
      }
    },

    async addJob(job) {
      if (job) {
        this.SET_JOBID(job.id);
        await this.load_infos_job(job.id);

        await axios
          .post('/api/work_station/' + this.infosPass.id_pass, {
            workStationNumber: this.job,
            pageTemplateId: job.id,
          })
          .then((response) => {
            this.initPage();
            this.toggleAddJobPopup(false);
            this.$emit('reloadPostes');
          })
          .catch((error) => {
            console.log(error.response);
          });
      }
      await this.getJob();
      await this.loadJobs();
    },

    toggleAddJobPopup(showing) {
      if (showing) {
        this.$refs.addJobPopup.resetSearchFields();
      }
      this.showAddJob = showing;
    },

    displayItem(numItem) {
      if (this.itemDisplayed == numItem) {
        this.itemDisplayed = -1;
      } else {
        this.itemDisplayed = numItem;
        let pos = document.getElementById('module' + numItem);
        setTimeout(() => {
          pos.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }, 800);
      }
    },

    async displayCompareCarto(typeCarto) {
      await this.load_infos_pass(this.infosPass.id_pass);

      Promise.all([this.load_evaluations()])
        .then(() => {
          this.compareCarto = true;
          this.cartoToCompare = typeCarto;
        })
        .catch((error) => {
          console.error(`Error while loading page: ${error}`);
        });
    },

    closeCompare() {
      this.compareCarto = false;
      this.cartoToCompare = '';
      this.historyToDisplay = -1;
    },

    changeCompare(index) {
      setTimeout(() => {
        this.historyToDisplay = -1;
      }, 300);
      setTimeout(() => {
        this.historyToDisplay = index;
      }, 300);
    },

    create_evaluation() {
      switch (this.jobType) {
        case 'ref_formation':
          this.create_ref_formation_evaluation();
          break;
        case 'rome':
          this.create_rome_evaluation();
          break;
        default:
          break;
      }
    },

    create_rome_evaluation() {
      let romeForm = {
        name_job: this.jobForm.nom_du_poste,
        template: 'ROME',
        id_ref: ['ROME', this.jobId],
        date_debut_evaluation: this.form.date_debut_evaluation,
        date_fin_evaluation: this.form.date_fin_evaluation,
        items: {
          competences_bases: { savoirs: {}, savoir_faire: {} },
          competences_spe: { savoirs: {}, savoir_faire: {} },
        },
      };

      if (
        this.jobForm?.competences_bases?.savoirs &&
        this.jobForm.competences_bases.savoirs.length > 0
      ) {
        romeForm.items.competences_bases.savoirs = {
          ...this.jobForm.competences_bases.savoirs.reduce(
            (carry, savoir) => ({ ...carry, [savoir]: false }),
            {}
          ),
        };
      }

      if (
        this.jobForm?.competences_bases?.savoir_faire &&
        this.jobForm.competences_bases.savoir_faire.length > 0
      ) {
        romeForm.items.competences_bases.savoir_faire = {
          ...this.jobForm.competences_bases.savoir_faire.reduce(
            (carry, savoir) => ({ ...carry, [savoir]: false }),
            {}
          ),
        };
      }

      if (
        this.jobForm?.competences_spe?.savoirs &&
        this.jobForm.competences_spe.savoirs.length > 0
      ) {
        romeForm.items.competences_spe.savoirs = {
          ...this.jobForm.competences_spe.savoirs.reduce(
            (carry, savoir) => ({ ...carry, [savoir]: false }),
            {}
          ),
        };
      }

      if (
        this.jobForm?.competences_spe?.savoir_faire &&
        this.jobForm.competences_spe.savoir_faire.length > 0
      ) {
        romeForm.items.competences_spe.savoir_faire = {
          ...this.jobForm.competences_spe.savoir_faire.reduce(
            (carry, savoir) => ({ ...carry, [savoir]: false }),
            {}
          ),
        };
      }

      this.form = romeForm;

      this.show_add_evaluation = false;
    },

    create_ref_formation_evaluation() {
      this.form.id_ref = [this.infosPage.id_template, this.jobId];
      axios
        .get('/api/page_templates/' + this.form.id_ref)
        .then((response) => {
          /* Load template for the form */
          let datas = response.data.data;

          let last_version = datas[datas.length - 1];
          this.form.version_template = datas.length;
          this.form.type_temp = response.data.type;
          this.form.name_temp = response.data.name;
          this.form.name_job = this.jobForm.nom_du_poste;

          if (last_version && last_version.length > 0) {
            this.form.template = last_version;
          } else {
            this.form.template = [];
          }

          this.jobForm.modules.forEach((mod, index) => {
            this.form.items.modules.push({
              libelle: mod.module_name,
              general: [],
              module_competences: [],
              module_competences_transversales: [],
            });
            /* Similar to what's done in the view, loop through every item in an activity, and only add it to the eval data if it is an array longer than 0,and if any of its children is an object.
                    Should probably be done with a flag in the future (activity[category].evaluable === true)
                    */
            for (const category in mod) {
              if (
                mod[category] != null &&
                mod[category].length > 0 &&
                mod[category].constructor.name === 'Array' &&
                mod[category].some(
                  (child) => child.constructor.name === 'Object'
                )
              ) {
                this.form.items.modules[index][category] = [];
              }
            }

            this.form.template
              .filter((t) => t.libelle !== "Critères d'évaluation")
              .forEach((templ) => {
                if (
                  mod.module_time &&
                  templ.libelle === 'Temps consacré' &&
                  templ.criterions.map((c) => c.value).includes(mod.module_time)
                ) {
                  this.form.items.modules[index].general.push({
                    name: templ.libelle,
                    value: mod.module_time,
                  });
                } else {
                  this.form.items.modules[index].general.push({
                    name: templ.libelle,
                    value: '',
                  });
                }
              });
            mod.module_competences.forEach((comp, iComp) => {
              this.form.items.modules[index].module_competences.push({
                name: comp.name,
                criterions: [],
              });

              comp.criterions.forEach((critere) => {
                this.form.items.modules[index].module_competences[
                  iComp
                ].criterions.push({
                  auto: '',
                  value: '',
                  comment: '',
                  name: critere.name,
                  indicateur: critere.indicateur,
                });
              });
            });
            mod.module_competences_transversales.forEach((comp, jComp) => {
              this.form.items.modules[
                index
              ].module_competences_transversales.push({
                name: comp.name,
                criterions: [],
              });

              comp.criterions.forEach((critere) => {
                this.form.items.modules[index].module_competences_transversales[
                  jComp
                ].criterions.push({
                  auto: '',
                  value: '',
                  comment: '',
                  name: critere.name,
                  indicateur: critere.indicateur,
                });
              });
            });
          });
        })
        .catch((error) => {
          console.log('ERRRR:: ', error);
        });
      this.show_add_evaluation = false;
    },

    close_eval() {
      this.close_evaluation(this.form);
      (this.form = {
        id_ref: 0,
        version_template: 0,
        type_temp: '',
        name_temp: '',
        template: [{}, {}],
        date_debut_evaluation: '',
        date_fin_evaluation: '',
        items: { modules: [] },
      }),
        (this.confirmCloseEvaluation = 1);
    },

    handleDeletedJobDesc(deletedDesc) {
      this.deletedDesc = deletedDesc;
      this.toggleAddJobPopup(true);
    },

    displayConfirmRemovePoste() {
      this.isPopupConfirmRemovePosteDisplayed = 0;
    },

    //TODO: if this needs to change again consider moving the popup and functions to a separate component
    async removeCurrentPoste() {
      try {
        await this.remove_poste(this.job).then((response) => {
          if (response === 200) {
            this.isPopupConfirmRemovePosteDisplayed = 1;
            this.jobForm = {};
            this.loadJobs();
          }
        });
      } catch (err) {}
    },

    displayTypeCompetenceChoice() {
      this.showTypeCompetenceChoice = !this.showTypeCompetenceChoice;
    },
  },
  computed: {
    ...mapGetters({
      formContent: 'neopass/formContent',
      infosPage: 'neopass/infosPage',
      infosPass: 'neopass/infosPass',
      user: 'auth/user',
      role: 'auth/role',
      cartoNeopassDatas: 'cartographiesIndividuelles/neopassDatas',
      cartoListEvaluations: 'cartographiesIndividuelles/listEvaluations',
      listEvaluations: 'neopass/listEvaluations',
      jobs: 'neopass/jobs',
      job: 'neopass/job',
      jobForm: 'neopass/jobForm',
      jobType: 'neopass/jobType',
      jobId: 'neopass/jobId',
    }),

    competencesSco: function () {
      return (
        (this.cartoNeopassDatas || {})[
          Constants.MODULE_NEOPASS_FORM_COMPETENCES_SCOLAIRES
        ] || {}
      );
    },

    historyCompetencesSco: function () {
      return (
        (this.cartoListEvaluations || {})[
          Constants.MODULE_NEOPASS_FORM_COMPETENCES_SCOLAIRES
        ] || {}
      );
    },

    today() {
      const options = { year: 'numeric', month: 'long', day: 'numeric' };
      return new Date().toLocaleDateString(undefined, options);
    },

    evalStartDate() {
      const options = { year: 'numeric', month: 'long', day: 'numeric' };
      if (this.form.date_debut_evaluation !== '') {
        return new Date(this.form.date_debut_evaluation).toLocaleDateString(
          undefined,
          options
        );
      } else {
        return new Date().toLocaleDateString(undefined, options);
      }
    },

    listCriterions() {
      return this.form.template.filter(
        (temp) => temp.libelle === "Critères d'évaluation"
      )[0].criterions;
    },

    latestEval() {
      let evaluationsWithActualSheetId = this.listEvaluations.filter(
        (evaluation) => evaluation.sheet_id === this.jobId
      );

      if (evaluationsWithActualSheetId.length > 0) {
        return evaluationsWithActualSheetId.filter(
          (eval0) =>
            Date.parse(eval0.end_at) ===
            Math.max(
              ...evaluationsWithActualSheetId.map((eval1) =>
                Date.parse(eval1.end_at)
              )
            )
        )[0].data;
      }

      return {};
    },
    isNewSheetPopupDisplayed() {
      return (
        (this.jobs[this.job - 1].number === undefined || this.jobNotFound) &&
        this.role !== Constants.ROLE_BENEFICIAIRE &&
        this.showAddJob
      );
    },

    jobNotFound() {
      return this.jobForm.deleted_at && this.jobForm.deleted_at !== null;
    },
  },

  watch: {
    form: {
      handler() {
        //assign true to flag to know if there is a change in form
        this.infosPage.isFormChanged = true;
      },
      deep: true,
    },
  },
  directives: {
    ClickOutside,
  },
};
</script>
